import { apiGet, apiPost, apiPatch, apiDelete } from '@/utils/api';

export interface PublicHoliday {
  id: string;
  tenantId: string;
  campusId?: string;
  year: number;
  name: string;
  nameAr?: string;
  startDate: string;
  endDate: string;
  isExtended: boolean;
  extendedBy?: string;
  source: 'API' | 'MANUAL' | 'TEMPLATE';
  isActive: boolean;
}

export interface CreateHolidayDto {
  campusId?: string;
  year: number;
  name: string;
  nameAr?: string;
  startDate: string;
  endDate: string;
}

export interface ExtendHolidayDto {
  extensionDays: number;
  extensionDirection: 'BEFORE' | 'AFTER' | 'BOTH';
  reason?: string;
}

class HolidaysService {
  async getHolidays(year: number, campusId?: string): Promise<PublicHoliday[]> {
    const params = new URLSearchParams();
    if (campusId) params.append('campusId', campusId);

    const queryString = params.toString() ? `?${params.toString()}` : '';
    return apiGet<PublicHoliday[]>(`/holidays/${year}${queryString}`);
  }

  async initializeHolidays(year: number, campusId?: string): Promise<{ message: string; count: number }> {
    return apiPost<{ message: string; count: number }>('/holidays/initialize', { year, campusId });
  }

  async createHoliday(data: CreateHolidayDto): Promise<PublicHoliday> {
    return apiPost<PublicHoliday>('/holidays', data);
  }

  async updateHoliday(id: string, data: Partial<CreateHolidayDto>): Promise<PublicHoliday> {
    return apiPatch<PublicHoliday>(`/holidays/${id}`, data);
  }

  async extendHoliday(id: string, data: ExtendHolidayDto): Promise<PublicHoliday> {
    return apiPatch<PublicHoliday>(`/holidays/${id}/extend`, data);
  }

  async deleteHoliday(id: string): Promise<void> {
    return apiDelete<void>(`/holidays/${id}`);
  }
}

export const holidaysService = new HolidaysService();
